export default {
  SECTION_SEARCH_RESULTS: 1,
  SECTION_SEARCH_RESULTS_NORESULT: 58,
  SECTION_SEARCH_RESULTS_KEYWORDS404: 95,
  SECTION_SEARCH_ONLY_NEW_ADS: 6,
  SECTION_SEARCH_BANNER_TOP: 26,
  SECTION_SEARCH_BANNER_BOTTOM: 27,
  SECTION_PAID_REGULARLANDING_ADS: 97,
  SECTION_PAID_REGULARLANDING_ADS_NORESULTS: 99,
  SECTION_PAID_REGULARLANDING_ADS_MORE: 130,
  SECTION_ADPAGE_VISIT_SOURCE: 186,
  SECTION_ADPAGE_VISIT_SOURCE_TYPE: 1,
  SECTION_ADPAGE_CONTACT_FORM: 4000,
  SECTION_ADPAGE_SIMILAR: 190,
  SECTION_SEARCH_DUPLICATE: 149,
  SECTION_PAID_SEARCH_DUPLICATE: 157,
  SECTION_PYA_ADPAGE_PAGINATOR_MLT: 160,
  SECTION_EXPIREDAD: 5,
  SECTION_SEARCH_FEWRESULTS: 206,
  SECTION_PAID_SEARCH_FEWRESULTS: 207,
  SECTION_RETENTION_FEATURED: 208,
  SECTION_ADSENSE_CLICK_TOP: 200,
  SECTION_ADSENSE_CLICK_BOTTOM: 201,
  APP_DOWNLOAD_SECTION_BUTTON: 3003,
  APP_DOWNLOAD_SECTION_ADPAGE_STICKY_BOTTOM: 3014,
  APP_DOWNLOAD_SECTION_FOOTER_ANDROID: 3015,
  APP_DOWNLOAD_SECTION_FOOTER_IOS: 3016,
  ALERT_CREATION_SECTION_MOBILE_BOTTOM: 10,
  ALERT_CREATION_SECTION_ADWORDS_MOBILE_BOTTOM: 11,
  ALERT_CREATION_SECTION_MOBILE_STICKY: 198,
  ALERT_CREATION_SECTION_MOBILE_STICKY_SEM: 199,
  ALERT_CREATION_SECTION_ADPAGE_FORM_CHECKBOX: 102,
  ALERT_CREATION_SECTION_STICKY: 92,
  ALERT_CREATION_SECTION_CHANNEL_SECTOR: 197,
};



// WEBPACK FOOTER //
// ./app/tracking/SectionIds.js